import React, { useEffect, useState } from "react"
import { useSiteContext } from "../hooks/use-site-context"
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"
import { graphql, useStaticQuery } from "gatsby"
import { FaHeart } from "react-icons/fa"
import { MdPlayArrow, MdPause, MdVolumeOff, MdVolumeUp } from "react-icons/md"
import speakerGif from "../images/speaker-icon.gif"

const Welcome = () => {
  const {
    selectedSign,
    audioEnded,
    mainAudio,
    setCurrentAudioStage,
    setAudioEnded,
    setCurrentStep,
    setFirstName,
    setLastName,
    setCurrentAudioTime,
    setEmailAddress,
    progressBarPercent,
    setProgressBarPercent,
    currentAudioTime,
    currentAudioStage,
    setUserCity,
    setUserRegion,
    setUserCountry,
  } = useSiteContext()

  const [disappearing, setDisappearing] = useState(false)
  const [isTransitioning, setIsTransitioning] = useState(false)
  const [stage, setStage] = useState(1)

  const imageData = useStaticQuery(graphql`
    {
      allFile(
        filter: { relativeDirectory: { eq: "signs-large" } }
        sort: { name: ASC }
      ) {
        edges {
          node {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED, quality: 95)
            }
            name
          }
        }
      }
    }
  `)

  async function getLocationData() {
    // Get user's city and country
    let ipAddress = null
    let json

    try {
      let res = await fetch("https://api.ipify.org")
      ipAddress = await res.text()
    } catch (error) {
      console.log(error)
    }

    if (ipAddress) {
      const response = await fetch("/.netlify/functions/location", {
        method: "POST",
        body: JSON.stringify({
          ip: ipAddress,
        }),
      })
      json = await response.json()
      console.log("Geolocation result:", json)
      if (json.data.status === "success") {
        setUserCity(json.data.city)
        setUserRegion(json.data.regionName)
        setUserCountry(json.data.country)
      }
    }
  }

  useEffect(() => {
    // document.body.style.overflow = "hidden"

    const isFirefox = navigator.userAgent.toLowerCase().includes("firefox")

    if (isFirefox) {
      // Custom smooth scroll for Firefox
      const smoothScrollToTop = () => {
        let currentScroll = window.scrollY
        if (currentScroll > 0) {
          window.scrollTo(0, currentScroll - currentScroll / 8) // Adjust easing factor if needed
          requestAnimationFrame(smoothScrollToTop)
        }
      }
      requestAnimationFrame(smoothScrollToTop)
    } else {
      // Native smooth scroll for Chrome, Safari, and others
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      })
    }

    let currentTick = 0
    const intervalID = setInterval(() => {
      currentTick++
      if (currentTick >= 410) {
        clearInterval(intervalID)
      } else {
        setProgressBarPercent(
          progressBarPercent => progressBarPercent + 33.33333 / 410
        )
      }
    }, 100)

    // Get user's location
    getLocationData()
  }, [])

  useEffect(() => {
    // console.log("Current audio time: ", currentAudioTime)
    if (stage === 2) {
      if (currentAudioTime > 18.4 && currentAudioStage === "my-name-is-james") {
        setIsTransitioning(true)
        setTimeout(() => {
          setStage(3)
          setIsTransitioning(false)
        }, 700)
      }
    }
    if (stage === 3) {
      if (currentAudioTime > 35 && currentAudioStage === "my-name-is-james") {
        setDisappearing(true)

        setTimeout(() => {
          setCurrentStep(3)
        }, 700)
      }
    }
  }, [currentAudioTime])

  useEffect(() => {
    if (audioEnded) {
      // Go to next clip
      const filename = mainAudio.src.split("/").pop()
      mainAudio.pause()

      if (filename !== "my-name-is-james.mp3") {
        setCurrentAudioStage("my-name-is-james")
        mainAudio.src = "/audio/my-name-is-james.mp3"
        mainAudio.play()
        setAudioEnded(false)
        setIsTransitioning(true)
        setTimeout(() => {
          if (window.location.search.includes("skip")) {
            setCurrentAudioTime(0) // For transitioning to closethesale
            setTimeout(() => {
              setFirstName("Takeupsell")
              setLastName("LastNameUpsell")
              setEmailAddress("testing94853353@gmail.com")
              setCurrentAudioStage(`phew-${selectedSign.toLowerCase()}`)
              mainAudio.src = `/audio/phew-${selectedSign.toLowerCase()}.mp3`
              mainAudio.play()
              setAudioEnded(false)
              setCurrentStep(10)
            }, 700)
          } else {
            setStage(2)
          }
          setIsTransitioning(false)
        }, 700)
      }
    }
  }, [audioEnded])

  return (
    <>
      <div
        className={`text-center fade-in ${
          disappearing ? "disappear transition duration-1000" : ""
        }`}
      >
        <h1 className="text-2xl font-bold text-white md:text-4xl">
          Welcome, {selectedSign}{" "}
          <FaHeart className="inline-block -translate-y-0.5 text-brand-pink" />
        </h1>
        {stage === 1 && (
          <div
            className={`relative mt-6 fade-in flex justify-center items-center ${
              isTransitioning ? "disappear transition duration-1000" : ""
            }`}
          >
            <div className="relative">
              {/* Zodiac Glow Image (background) */}
              <GatsbyImage
                image={
                  imageData.allFile.edges.filter(edge =>
                    edge.node.name.includes(selectedSign.toLowerCase())
                  )[0].node.childImageSharp.gatsbyImageData
                }
                loading={"eager"}
                alt={selectedSign}
                className="w-64 h-64 md:w-96 md:h-96 zodiac-glow"
                style={{
                  position: "absolute", // Ensure it layers behind
                  zIndex: 1,
                }}
              />

              {/* Slow Pulse Image (foreground) */}
              <GatsbyImage
                image={
                  imageData.allFile.edges.filter(edge =>
                    edge.node.name.includes(selectedSign.toLowerCase())
                  )[0].node.childImageSharp.gatsbyImageData
                }
                loading={"eager"}
                alt={selectedSign}
                className="w-64 h-64 md:w-96 md:h-96 slow-pulse"
                style={{
                  position: "relative", // Stacks on top
                  zIndex: 2,
                }}
              />
            </div>
          </div>
        )}
        {stage === 2 && (
          <div
            className={`relative mt-6 fade-in flex justify-center items-center ${
              isTransitioning ? "disappear transition duration-1000" : ""
            }`}
          >
            <div className="relative">
              {/* Zodiac Glow Image (background) */}
              <StaticImage
                quality={95}
                loading={"eager"}
                src="../images/james-png.png"
                placeholder="blurred"
                alt="james"
                className="w-64 h-64 md:w-96 md:h-96 zodiac-glow"
                style={{
                  position: "absolute", // Ensure it layers behind
                  zIndex: 1,
                }}
              />

              {/* Slow Pulse Image (foreground) */}
              <StaticImage
                quality={95}
                loading={"eager"}
                src="../images/james-png.png"
                placeholder="blurred"
                alt="james"
                className="w-64 h-64 md:w-96 md:h-96 slow-pulse"
                style={{
                  position: "relative", // Stacks on top
                  zIndex: 2,
                }}
              />
              <div className="mt-6 fade-in-speaker">
                <img
                  src={speakerGif}
                  alt="speaker icon"
                  className="w-10 h-10 mx-auto md:w-12 md:h-12 opacity-60"
                />
              </div>
            </div>
          </div>
        )}
        {stage === 3 && (
          <div
            className={`relative mt-6 fade-in flex justify-center items-center ${
              isTransitioning ? "disappear transition duration-1000" : ""
            }`}
          >
            <div className="relative">
              {/* Zodiac Glow Image (background) */}
              <StaticImage
                quality={95}
                loading={"eager"}
                src="../images/warning.png"
                placeholder="blurred"
                alt="warning sign"
                className="w-64 h-64 md:w-96 md:h-96 zodiac-glow"
                style={{
                  position: "absolute", // Ensure it layers behind
                  zIndex: 1,
                }}
              />

              {/* Slow Pulse Image (foreground) */}
              <StaticImage
                quality={95}
                loading={"eager"}
                src="../images/warning.png"
                placeholder="blurred"
                alt="warning sign"
                className="w-64 h-64 md:w-96 md:h-96 slow-pulse"
                style={{
                  position: "relative", // Stacks on top
                  zIndex: 2,
                }}
              />
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default Welcome
